import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGetProductsWithMedicationsQuery } from "src/api/services/productsApi";
import { usePatient } from "src/context/PatientProvider";
import { useFetchCarouselProducts } from "src/hooks/useFetchCarouselProducts";
import { useIsMobile } from "src/hooks/useIsMobile";
import ProductCarousel from "src/shared/components/ProductCarousel";
import TimesOneMobiledataIcon from "@mui/icons-material/TimesOneMobiledata";
import CarouselSkeleton from "src/shared/components/CarouselSkeleton";
import { useRecommendedDosage } from "src/context/RecommendedDosageProvider";
import ProductItems from "src/components/ProductItems";

const TryOnce = () => {
  const isMobile = useIsMobile();
  const gender = usePatient((p) => p.profile.gender);
  const { t } = useTranslation();
  const component = "tryOnceCarousel";
  const { data = [], isLoading } = useGetProductsWithMedicationsQuery(
    {
      gender: gender as string,
    },
    { skip: !gender },
  );
  const recommendedDose = useRecommendedDosage();

  const { oneTimeProducts } = useFetchCarouselProducts(data);

  return isLoading ? (
    <CarouselSkeleton />
  ) : oneTimeProducts.length === 0 ? null : (
    <Stack width={"100%"}>
      <Stack gap={0.5}>
        <Stack
          direction={"row"}
          justifyContent={isMobile ? "space-between" : ""}
          gap={isMobile ? 0 : 1}
        >
          <Typography variant="h5" fontWeight={600}>
            {t(`${component}.header`)}
          </Typography>
          <TimesOneMobiledataIcon fontSize="large" />
        </Stack>
        <Typography variant="h5" color="#9E9FA0" fontWeight={600}>
          {t(`${component}.subheader`, "No recurring charges")}
        </Typography>
      </Stack>
      <ProductCarousel>
        <ProductItems
          products={oneTimeProducts}
          recommendedDose={recommendedDose}
        />
      </ProductCarousel>
    </Stack>
  );
};

export default TryOnce;
